export const rubrosHistoricos = [
    {
        "anio" : "2026",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2026trim1.zip"
            },
            // {
            //     "trimestre" : "Segundo Trimestre",
            //     "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2026trim2.zip"
            // },
            // {
            //     "trimestre" : "Tercer Trimestre",
            //     "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2026trim3.zip"
            // },
            // {
            //     "trimestre" : "Cuarto Trimestre",
            //     "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2026trim4.zip"
            // }
        ]
    },
    {
        "anio" : "2025",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2025trim1.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2025trim1.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2025trim2.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2025trim2.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2025trim3.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2025trim3.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2025trim4.zip"
            }
        ]
    },
    {
        "anio" : "2024",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2024trim1.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2024trim1.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2024trim2.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2024trim2.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2024trim3.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2024trim3.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2024trim4.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2024trim4.zip"
            }
        ]
    },
    {
        "anio" : "2023",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2023trim1.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2023trim1.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2023trim2.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2023trim2.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2023trim3.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2023trim3.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2023trim4.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2023trim4.zip"
            }
        ]
    },
    {
        "anio" : "2022",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2022trim1.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2022trim1.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2022trim2.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2022trim2.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2022trim3.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2022trim3.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2022trim4.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2022trim4.zip"
            }
        ]
    },
    {
        "anio" : "2021",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2021trim1.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2021trim1.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2021trim2.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2021trim2.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2021trim3.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2021trim3.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2021trim4.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2021trim4.zip"
            }
        ]
    },
    {
        "anio" : "2020",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2020trim1.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2020trim1.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2020trim2.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2020trim2.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2020trim3.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2020trim3.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2020trim4.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2020trim4.zip"
            }
        ]
    },
    {
        "anio" : "2019",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2019trim1.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2019trim1.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2019trim2.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2019trim2.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2019trim3.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2019trim3.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2019trim4.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2019trim4.zip"
            }
        ]
    },
    {
        "anio" : "2018",
        "descripcion" : "Disponibilidad de los trimestres anteriores",
        "trimestres" : [
            {
                "trimestre" : "Primer Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2018trim1.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2018trim1.zip"
            },
            {
                "trimestre" : "Segundo Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2018trim2.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2018trim2.zip"
            },
            {
                "trimestre" : "Tercer Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2018trim3.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2018trim3.zip"
            },
            {
                "trimestre" : "Cuarto Trimestre",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/2018trim4.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/2018trim4.zip"
            }
        ]
    },
    {
        "anio" : "2015 - 2017",
        "descripcion" : "Ejercicios Anteriores",
        "trimestres" : [
            {
                "trimestre" : "Plataforma Nacional",
                "url" : "https://consultapublicamx.inai.org.mx/vut-web/?idSujetoObigadoParametro=2131&idEntidadParametro=13&idSectorParametro=21"
            }
        ]
    },
    {
        "anio" : "Información Histórica 21 Rubros",
        "descripcion" : "Ejercicios Anteriores",
        "trimestres" : [
            {
                "trimestre" : "Descargar",
                "url" : "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/hist/21Rubros.zip"
                // "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/historico/21Rubros.zip"
            }
        ]
    }
]